/* eslint-disable no-param-reassign */
/* eslint-disable object-curly-newline */
/* eslint-env jquery */

import { Component, registerComponent } from 'js/component.js';

const componentName = 'software-license-form';
class SoftwareLicenseForm extends Component {
    elements = {
        // Display
        container: this.element.querySelector(`.${componentName}__container`),
        modalContainer: this.element.closest('dialog'),
        signedOutContent: this.element.querySelector(`.${componentName}__content--unauthenticated`),
        formSuccessContent: this.element.querySelector(`.${componentName}__content--success`),
        formIneligibleContent: this.element.querySelector(`.${componentName}__content--ineligible`),
        formLimitReachedContent: this.element.querySelector(`.${componentName}__content--limit-reached`),
        formErrorContent: this.element.querySelector(`.${componentName}__content--error`),
        formContent: this.element.querySelector(`.${componentName}__content--form`),
        loaderContent: this.element.querySelector(`.${componentName}__content--loading`),
        // Form
        form: this.element.querySelector('form'),
        formSubmitButton: this.element.querySelector(`.${componentName}__form-submit`),
        signInLink: this.element.querySelector(`.${componentName}__content-action--sign-in`),
        closeDialogButtons: this.element.querySelectorAll(`.${componentName}__content-action--cancel`),
        defaultCountryOptions: this.element.querySelector(`.${componentName}-default-options--country`),
        countrySelect: this.element.querySelector('select[name="$Country"]'),
        stateSelect: this.element.querySelector('select[name="$StateorProvince"]'),
        // Hidden Inputs
        bpidInput: this.element.querySelector('input[name="$Question2Text"]'),
        hiddenEmailInput: this.element.querySelector('input[name="$PrepopEmailAddress"]'),
        urlInput: this.element.querySelector('input[name="$FormURL"]'),
    };

    state = {
        isSignedIn: false,
        userInfo: {
            origin: 'Marketing',
            isTest: false,
            shipToBpid: '',
            softwarePortalLoginEmail: '',
            catalogNumber: '',
            intendedUse: '',
            contactFirstName: '',
            contactLastName: '',
            contactEmail: '',
            contactPhone: '',
            contactCompany: '',
            contactAddress1: '',
            contactAddress2: '',
            contactCity: '',
            contactProvince: 'N/A',
            contactPostCode: '',
            contactCountryCode: '',
            contactCountryName: '',
            contactFax: '',
        },
        userLicenseStatus: 'eligible',
        stateInputType: 'select',
    };

    constants = {
        eloquaEndpoint: '',
        licenseServletEndpoint: '/bin/rockwell-automation/software-license',
        theme: 'ra',
        requiredFields: [
            'origin',
            'softwarePortalLoginEmail',
            'catalogNumber',
            'intendedUse',
            'contactFirstName',
            'contactLastName',
            'contactEmail',
            'contactCompany',
            'contactAddress1',
            'contactCity',
            'contactProvince',
            'contactPostCode',
            'contactCountryCode',
            'contactCountryName',
        ],
        formFieldToUserInfoMap: {
            '$FirstName': 'contactFirstName',
            '$LastName': 'contactLastName',
            '$EmailAddress': 'contactEmail',
            '$Telephone': 'contactPhone',
            '$Company': 'contactCompany',
            '$AddressLine1': 'contactAddress1',
            '$AddressLine2': 'contactAddress2',
            '$City': 'contactCity',
            '$StateorProvince': 'contactProvince',
            '$Postcode': 'contactPostCode',
            '$Country': 'contactCountryName',
            '$Fax': 'contactFax',
            '$Comments': 'intendedUse',
        },
        countryToStatesMap: {
            "United States": [
                { "name": "Alabama", "code": "AL" },
                { "name": "Alaska", "code": "AK" },
                { "name": "Arizona", "code": "AZ" },
                { "name": "Arkansas", "code": "AR" },
                { "name": "American Samoa", "code": "AS" },
                { "name": "California", "code": "CA" },
                { "name": "Colorado", "code": "CO" },
                { "name": "Connecticut", "code": "CT" },
                { "name": "Delaware", "code": "DE" },
                { "name": "District Of Columbia", "code": "DC" },
                { "name": "Florida", "code": "FL" },
                { "name": "Georgia", "code": "GA" },
                { "name": "Guam", "code": "GU" },
                { "name": "Hawaii", "code": "HI" },
                { "name": "Idaho", "code": "ID" },
                { "name": "Illinois", "code": "IL" },
                { "name": "Indiana", "code": "IN" },
                { "name": "Iowa", "code": "IA" },
                { "name": "Kansas", "code": "KS" },
                { "name": "Kentucky", "code": "KY" },
                { "name": "Louisiana", "code": "LA" },
                { "name": "Maine", "code": "ME" },
                { "name": "Marshall Islands", "code": "MH" },
                { "name": "Maryland", "code": "MD" },
                { "name": "Massachusetts", "code": "MA" },
                { "name": "Michigan", "code": "MI" },
                { "name": "Minnesota", "code": "MN" },
                { "name": "Mississippi", "code": "MS" },
                { "name": "Missouri", "code": "MO" },
                { "name": "Montana", "code": "MT" },
                { "name": "Nebraska", "code": "NE" },
                { "name": "Nevada", "code": "NV" },
                { "name": "New Hampshire", "code": "NH" },
                { "name": "New Jersey", "code": "NJ" },
                { "name": "New Mexico", "code": "NM" },
                { "name": "New York", "code": "NY" },
                { "name": "North Carolina", "code": "NC" },
                { "name": "North Dakota", "code": "ND" },
                { "name": "Northern Mariana Islands", "code": "MP" },
                { "name": "Ohio", "code": "OH" },
                { "name": "Oklahoma", "code": "OK" },
                { "name": "Oregon", "code": "OR" },
                { "name": "Pennsylvania", "code": "PA" },
                { "name": "Puerto Rico", "code": "PR" },
                { "name": "Rhode Island", "code": "RI" },
                { "name": "South Carolina", "code": "SC" },
                { "name": "South Dakota", "code": "SD" },
                { "name": "Tennessee", "code": "TN" },
                { "name": "Texas", "code": "TX" },
                { "name": "Utah", "code": "UT" },
                { "name": "Vermont", "code": "VT" },
                { "name": "Virgin Islands", "code": "VI" },
                { "name": "Virginia", "code": "VA" },
                { "name": "Washington", "code": "WA" },
                { "name": "West Virginia", "code": "WV" },
                { "name": "Wisconsin", "code": "WI" },
                { "name": "Wyoming", "code": "WY" }
            ],
            "Canada": [
                { "name": "Alberta", "code": "AB" },
                { "name": "British Columbia", "code": "BC" },
                { "name": "Manitoba", "code": "MB" },
                { "name": "New Brunswick", "code": "NB" },
                { "name": "Newfoundland and Labrador", "code": "NL" },
                { "name": "Northwest Territories", "code": "NT" },
                { "name": "Nova Scotia", "code": "NS" },
                { "name": "Nunavut", "code": "NU" },
                { "name": "Ontario", "code": "ON" },
                { "name": "Prince Edward Island", "code": "PE" },
                { "name": "Quebec", "code": "QC" },
                { "name": "Saskatchewan", "code": "SK" },
                { "name": "Yukon", "code": "YT" }
            ],
            "Australia": [
                { "name": "Australian Capital Territory", "code": "ACT" },
                { "name": "New South Wales", "code": "NSW" },
                { "name": "Northern Territory", "code": "NT" },
                { "name": "Queensland", "code": "QLD" },
                { "name": "South Australia", "code": "SA" },
                { "name": "Tasmania", "code": "TAS" },
                { "name": "Victoria", "code": "VIC" },
                { "name": "Western Australia", "code": "WA" }
            ],
            "China": [
                { "name": "Anhui", "code": "AH" },
                { "name": "Beijing", "code": "BJ" },
                { "name": "Chongqing", "code": "CQ" },
                { "name": "Fujian", "code": "FJ" },
                { "name": "Gansu", "code": "GS" },
                { "name": "Guangdong", "code": "GD" },
                { "name": "Guangxi", "code": "GX" },
                { "name": "Guizhou", "code": "GZ" },
                { "name": "Hainan", "code": "HI" },
                { "name": "Hebei", "code": "HE" },
                { "name": "Heilongjiang", "code": "HL" },
                { "name": "Henan", "code": "HA" },
                { "name": "Hubei", "code": "HB" },
                { "name": "Hunan", "code": "HN" },
                { "name": "Inner Mongolia", "code": "NM" },
                { "name": "Jiangsu", "code": "JS" },
                { "name": "Jiangxi", "code": "JX" },
                { "name": "Jilin", "code": "JL" },
                { "name": "Liaoning", "code": "LN" },
                { "name": "Ningxia", "code": "NX" },
                { "name": "Qinghai", "code": "QH" },
                { "name": "Shaanxi", "code": "SN" },
                { "name": "Shandong", "code": "SD" },
                { "name": "Shanghai", "code": "SH" },
                { "name": "Shanxi", "code": "SX" },
                { "name": "Sichuan", "code": "SC" },
                { "name": "Tianjin", "code": "TJ" },
                { "name": "Tibet", "code": "XZ" },
                { "name": "Xinjiang", "code": "XJ" },
                { "name": "Yunnan", "code": "YN" },
                { "name": "Zhejiang", "code": "ZJ" }
            ],
            "India": [
                { "name": "Andhra Pradesh", "code": "AP" },
                { "name": "Arunachal Pradesh", "code": "AR" },
                { "name": "Assam", "code": "AS" },
                { "name": "Bihar", "code": "BR" },
                { "name": "Chhattisgarh", "code": "CG" },
                { "name": "Goa", "code": "GA" },
                { "name": "Gujarat", "code": "GJ" },
                { "name": "Haryana", "code": "HR" },
                { "name": "Himachal Pradesh", "code": "HP" },
                { "name": "Jharkhand", "code": "JH" },
                { "name": "Karnataka", "code": "KA" },
                { "name": "Kerala", "code": "KL" },
                { "name": "Madhya Pradesh", "code": "MP" },
                { "name": "Maharashtra", "code": "MH" },
                { "name": "Manipur", "code": "MN" },
                { "name": "Meghalaya", "code": "ML" },
                { "name": "Mizoram", "code": "MZ" },
                { "name": "Nagaland", "code": "NL" },
                { "name": "Odisha", "code": "OR" },
                { "name": "Punjab", "code": "PB" },
                { "name": "Rajasthan", "code": "RJ" },
                { "name": "Sikkim", "code": "SK" },
                { "name": "Tamil Nadu", "code": "TN" },
                { "name": "Telangana", "code": "TG" },
                { "name": "Tripura", "code": "TR" },
                { "name": "Uttar Pradesh", "code": "UP" },
                { "name": "Uttarakhand", "code": "UK" },
                { "name": "West Bengal", "code": "WB" },
                { "name": "Andaman and Nicobar Islands", "code": "AN" },
                { "name": "Chandigarh", "code": "CH" },
                { "name": "Dadra and Nagar Haveli and Daman and Diu", "code": "DN" },
                { "name": "Lakshadweep", "code": "LD" },
                { "name": "Delhi", "code": "DL" },
                { "name": "Puducherry", "code": "PY" },
                { "name": "Ladakh", "code": "LA" },
                { "name": "Jammu and Kashmir", "code": "JK" }
            ]
        },
        regionNotRequiredCountries: [
            "Japan",
        ],
    };

    checkSignInStatus = () => {
        let loggedInData;
        if (window['userData']) {
            this.state.isSignedIn = true;
            loggedInData = window['userData'];
        } else if (localStorage.getItem('loggedInData')) {
            try {
                loggedInData = JSON.parse(localStorage.getItem('loggedInData'));
                this.state.isSignedIn = true;
            } catch (e) {
                console.warn('Error parsing loggedInData from localStorage', e);
            }
        }
        if (loggedInData) {
            this.state.userInfo.contactFirstName = loggedInData.firstName || '';
            this.state.userInfo.contactLastName = loggedInData.lastName || '';
            this.state.userInfo.contactEmail = loggedInData.email || '';
            this.state.userInfo.softwarePortalLoginEmail = loggedInData.email || '';
            this.state.userInfo.contactPhone = loggedInData.phone || '';
            this.state.userInfo.contactCompany = loggedInData.company || '';
            this.state.userInfo.contactAddress1 = loggedInData.address || '';
            this.state.userInfo.contactCity = loggedInData.city || '';
            this.state.userInfo.contactProvince = loggedInData.region || '';
            this.state.userInfo.contactPostCode = loggedInData.zip || '';
            this.state.userInfo.contactCountryCode = loggedInData.countryCode || '';
            this.state.userInfo.contactCountryName = loggedInData.country || '';
            this.state.userInfo.shipToFirstName = loggedInData.firstName || '';
            this.state.userInfo.shipToBpid = loggedInData.bpid || '';
        }
    };

    checkLicenseEligibility = async () => {
        let status = 'error';
        const licenseRequestUrl = new URL(this.constants.licenseServletEndpoint, window.location.origin);
        Object.keys(this.state.userInfo).forEach((key) => {
            licenseRequestUrl.searchParams.append(key, this.state.userInfo[key]);
        });
        try {
            const response = await fetch(licenseRequestUrl, {
                method: 'GET',
            });
            if (response.ok) {
                const data = await response.json();
                if (data.message === 'Success') {
                    status = 'success';
                } else if (data.id == 3001) {
                    status = 'limit-reached';
                } else if (data.id == 3004) {
                    status = 'ineligible';
                } else {
                    status = 'error';
                }
            } else {
                status = 'error';
            }
        } catch (error) {
            console.warn('Error fetching license eligibility:', error);
            status = 'error';
        }
        window.digitalData = window.digitalData || [];
        const formEvent = {
            event: 'formSubmit',
            formSubmitDetail: {
                status: status === 'success' ? status : 'error',
                formName: this.elements.modalContainer.id,
            }
        };
        if (status !== 'success') {
            formEvent.formSubmitDetail.errorMessage = status;
        }
        window.digitalData.push(formEvent);
        return status;
    };

    postToEloqua = async (formData) => {
        if (!this.constants.eloquaEndpoint) {
            console.warn('Eloqua endpoint is not set.');
            return;
        }
        try {
            const eloquaRequestUrl = new URL(this.constants.eloquaEndpoint);
            const eloquaPostBody = {};
            for (const [key, value] of formData.entries()) {
                if (key === '$Telephone--country-code') {
                    continue;
                } else if (key === '$Telephone') {
                    eloquaPostBody[key] = `${formData.get('$Telephone--country-code')}${value}`;
                } else if (key === '$PrepopEmailAddress') {
                    eloquaPostBody[key] = value;
                    eloquaPostBody['$EmailAddress'] = value;
                } else if (key === '$StateorProvince') {
                    if (this.state.stateInputType === 'select') {
                        eloquaPostBody['$StateorProvince'] = value;
                    }
                } else {
                    eloquaPostBody[key] = value;
                }
            }

            // Check for UTM parameters in query string
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get('utm_campaign')) {
                eloquaPostBody['utm_campaign'] = urlParams.get('utm_campaign');
            }
            if (urlParams.get('utm_creative')) {
                eloquaPostBody['utm_creative'] = urlParams.get('utm_creative');
            }
            if (urlParams.get('utm_medium')) {
                eloquaPostBody['utm_medium'] = urlParams.get('utm_medium');
            }
            if (urlParams.get('utm_placement')) {
                eloquaPostBody['utm_placement'] = urlParams.get('utm_placement');
            }
            if (urlParams.get('utm_source')) {
                eloquaPostBody['utm_source'] = urlParams.get('utm_source');
            }
            if (urlParams.get('utm_content')) {
                eloquaPostBody['utm_content'] = urlParams.get('utm_content');
            }
            if (urlParams.get('utm_term')) {
                eloquaPostBody['utm_term'] = urlParams.get('utm_term');
            }

            const response = await fetch(eloquaRequestUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                mode: 'no-cors',
                body: new URLSearchParams(eloquaPostBody),
            });
            const data = await response.text();
            if (!response.ok) {
                console.warn('Eloqua error:', data);
            }
            return data;
        } catch (error) {
            console.warn('Error posting to Eloqua:', error);
            return;
        }
    };

    setUserInfo = (formData) => {
        for (const [key, value] of formData.entries()) {
            if (this.constants.formFieldToUserInfoMap[key]) {
                if (key === '$Telephone') {
                    this.state.userInfo[this.constants.formFieldToUserInfoMap[key]] = `${formData.get('$Telephone--country-code')}${value}`;
                } else if (key === '$StateorProvince') {
                    if (this.state.stateInputType === 'none') {
                        this.state.userInfo[this.constants.formFieldToUserInfoMap[key]] = 'N/A';
                    } else if (this.state.stateInputType === 'select') {
                        this.state.userInfo[this.constants.formFieldToUserInfoMap[key]] = value || this.state.userInfo[this.constants.formFieldToUserInfoMap[key]];
                    }
                } else {
                    this.state.userInfo[this.constants.formFieldToUserInfoMap[key]] = value || this.state.userInfo[this.constants.formFieldToUserInfoMap[key]];
                }
            }
        }
    };

    presetFormFields = () => {
        const formFields = this.elements.form.querySelectorAll('input, select');
        formFields.forEach((field) => {
            const fieldName = field.getAttribute('name');
            if (this.constants.formFieldToUserInfoMap[fieldName]) {
                const userInfoKey = this.constants.formFieldToUserInfoMap[fieldName];
                if (this.state.userInfo[userInfoKey]) {
                    field.value = this.state.userInfo[userInfoKey];
                }
            }
        });
    };

    handleCountryChange = () => {
        const selectedCountry = this.elements.countrySelect.value;
        const selectedCountryStates = this.constants.countryToStatesMap[selectedCountry] || [];

        if (this.elements.stateSelect) {
            if (this.constants.regionNotRequiredCountries.includes(selectedCountry) || selectedCountryStates.length === 0) {
                this.elements.stateSelect.closest(`.${this.constants.theme}-formfield`).classList.add('hidden');
                this.state.stateInputType = 'none';
            } else {
                this.elements.stateSelect.closest(`.${this.constants.theme}-formfield`).classList.remove('hidden');
                this.state.stateInputType = 'select';
                this.elements.stateSelect.innerHTML = '';
                const defaultOptionEle = document.createElement('option');
                defaultOptionEle.value = '';
                defaultOptionEle.text = '';
                defaultOptionEle.selected = true;
                this.elements.stateSelect.appendChild(defaultOptionEle);
                selectedCountryStates.forEach((state) => {
                    const optionEle = document.createElement('option');
                    optionEle.value = state.code;
                    optionEle.text = state.name;
                    this.elements.stateSelect.appendChild(optionEle);
                });
            }
        }
    };

    /**
     * Handle Validation
     */
    handleValidation = () => {
        let hasError = false;
        const requiredFields = this.element.querySelectorAll('input[data-required], textarea[data-required], select[data-required]');

        [...requiredFields].forEach((fieldEle) => {
            if (fieldEle.disabled || fieldEle.closest(`.${this.constants.theme}-formfield`).classList.contains('hidden')) {
                return;
            }
            const isText = fieldEle.classList.contains(`${this.constants.theme}-input__input`);
            const isCheckbox = fieldEle.classList.contains(`${this.constants.theme}-checkbox__checkbox`);
            const isSelect = fieldEle.classList.contains(`${this.constants.theme}-select__select`);

            // Text Fields
            if (isText) {
                const inputValue = fieldEle.value;
                const isEmpty = inputValue === '';
                const parentContainerEle = fieldEle.closest(`.${this.constants.theme}-formfield`);
                const errorMessage = parentContainerEle.querySelector(`.${this.constants.theme}-formfield__caption-error`);

                if (isEmpty) {
                    hasError = true;
                    parentContainerEle.classList.add(`${this.constants.theme}-formfield--invalid`);
                    fieldEle.classList.add(`${this.constants.theme}-input__input--invalid`);
                    if (errorMessage) {
                        errorMessage.setAttribute('aria-hidden', 'false');
                    }
                } else {
                    parentContainerEle.classList.remove(`${this.constants.theme}-formfield--invalid`);
                    fieldEle.classList.remove(`${this.constants.theme}-input__input--invalid`);
                    if (errorMessage) {
                        errorMessage.setAttribute('aria-hidden', 'true');
                    }
                }
            }

            // Checkboxes
            if (isCheckbox) {
                const parentContainerEle = fieldEle.closest(`.${this.constants.theme}-formfield`);
                const errorMessage = parentContainerEle.querySelector(`.${this.constants.theme}-formfield__caption-error`);
                let isEmpty = true;

                [...inputEles].forEach((inputEle) => {
                    if (inputEle.checked === true) {
                        isEmpty = false;
                    }
                });

                if (isEmpty) {
                    hasError = true;
                    parentContainerEle.classList.add(`${this.constants.theme}-formfield--invalid`);
                    fieldEle.classList.add(`${this.constants.theme}-checkbox__checkbox--invalid`);
                    if (errorMessage) {
                        errorMessage.setAttribute('aria-hidden', 'false');
                    }
                } else {
                    parentContainerEle.classList.remove(`${this.constants.theme}-formfield--invalid`);
                    fieldEle.classList.remove(`${this.constants.theme}-checkbox__checkbox--invalid`);
                    if (errorMessage) {
                        errorMessage.setAttribute('aria-hidden', 'true');
                    }
                }
            }

            // Selects
            if (isSelect) {
                const isEmpty = fieldEle.value === '';
                const parentContainerEle = fieldEle.closest(`.${this.constants.theme}-formfield`);
                const errorMessage = parentContainerEle.querySelector(`.${this.constants.theme}-formfield__caption-error`);

                if (isEmpty) {
                    hasError = true;
                    parentContainerEle.classList.add(`${this.constants.theme}-formfield--invalid`);
                    fieldEle.classList.add(`${this.constants.theme}-select__select--invalid`);
                    if (errorMessage) {
                        errorMessage.setAttribute('aria-hidden', 'false');
                    }
                } else {
                    parentContainerEle.classList.remove(`${this.constants.theme}-formfield--invalid`);
                    fieldEle.classList.remove(`${this.constants.theme}-select__select--invalid`);
                    if (errorMessage) {
                        errorMessage.setAttribute('aria-hidden', 'true');
                    }
                }
            }
        });

        return hasError;
    };

    addEventListeners = () => {
        this.elements.form.addEventListener('submit', async (event) => {
            event.preventDefault();

            const hasError = this.handleValidation();
            if (hasError) {
                return;
            }

            this.elements.formSubmitButton.classList.add('loading');
            const formData = new FormData(this.elements.form);
            this.setUserInfo(formData);

            const eloquaResponse = await this.postToEloqua(formData);
            const response = await this.checkLicenseEligibility();

            this.elements.formContent.classList.remove('active');
            switch (response) {
                case 'success':
                    this.elements.formSuccessContent.classList.add('active');
                    break;
                case 'ineligible':
                    this.elements.formIneligibleContent.classList.add('active');
                    break;
                case 'limit-reached':
                    this.elements.formLimitReachedContent.classList.add('active');
                    break;
                case 'error':
                    this.elements.formErrorContent.classList.add('active');
                    break;
                default:
                    break;
            }
            this.elements.formSubmitButton.classList.remove('loading');
        });

        this.elements.form.querySelectorAll('select').forEach((select) => {
            select.addEventListener('change', () => {
                if (select.value) {
                    select.classList.add('has-value');
                } else {
                    select.classList.remove('has-value');
                }
            });
        });

        this.elements.closeDialogButtons.forEach((button) => {
            button.addEventListener('click', () => {
                this.elements.modalContainer.close();
            });
        });

        this.elements.countrySelect.addEventListener('change', this.handleCountryChange);
    };

    initDom = () => {
        // Check sign-in status
        this.checkSignInStatus();
        if (!this.state.isSignedIn) {
            this.elements.loaderContent.classList.remove('active');
            this.elements.signedOutContent.classList.add('active');
            this.elements.signInLink.addEventListener('click', () => {
                if (document.querySelector('.account-menu__sign-in')) {
                    document.querySelector('.account-menu__sign-in').click();
                } else {
                    if (localStorage.getItem('adfsLogin')) {
                        window.location.href = localStorage.getItem('adfsLogin');
                    }
                }
            });
            return;
        }

        // Set data values
        this.state.userInfo.origin = this.elements.container.getAttribute('data-origin') || this.state.userInfo.origin;
        this.state.userInfo.catalogNumber = this.elements.container.getAttribute('data-catalog-number') || this.state.userInfo.catalogNumber;
        this.constants.theme = this.elements.container.getAttribute('data-theme') || this.constants.theme;
        this.constants.eloquaEndpoint = this.elements.container.getAttribute('data-eloqua-endpoint') || this.constants.eloquaEndpoint;
        this.elements.urlInput.value = window.location.origin + window.location.pathname;
        this.elements.bpidInput.value = this.state.userInfo.shipToBpid || this.elements.bpidInput.value;
        this.elements.hiddenEmailInput.value = this.state.userInfo.softwarePortalLoginEmail || this.elements.hiddenEmailInput.value;


        // Init form fields
        if (this.elements.countrySelect && this.elements.countrySelect.querySelectorAll('option').length <= 1) {
            this.elements.defaultCountryOptions.querySelectorAll('option').forEach(option => {
                this.elements.countrySelect.appendChild(option);
            });
        }
        this.elements.defaultCountryOptions.remove();

        this.presetFormFields();
        if (this.elements.stateSelect) {
            this.handleCountryChange();
            this.elements.stateSelect.value = this.state.userInfo.contactProvince || this.elements.stateSelect.value;
        }

        this.elements.form.querySelectorAll('select').forEach((select) => {
            if (select.value) {
                select.classList.add('has-value');
            } else {
                select.classList.remove('has-value');
            }
        });

        this.elements.form.querySelector('input[name="$EmailAddress"]').disabled = true;
        this.elements.form.querySelector('input[name="$EmailAddress"]').classList.add('ra-input__input--disabled');
        this.elements.loaderContent.classList.remove('active');
        this.elements.formContent.classList.add('active');
    };

    /**
     * Initialize Component
     */
    init = () => {
        if (typeof getPiraObj === 'function' || window.location.hostname.includes('localhost')) {
            this.initDom();
            this.addEventListeners();
        } else {
            document.addEventListener('piraLoadedSynced', () => {
                this.initDom();
                this.addEventListeners();
            });
        }
    };
}

registerComponent(`.${componentName}`, SoftwareLicenseForm);
